interface StepHeaderProps {
  title: string;
  subTitle: string;
  image: string;
}
export function StepHeader({ title, subTitle, image }: StepHeaderProps) {
  return (
    <div>
      <div className="mb-4 flex justify-center">
        <img src={image} alt={title} className="h-12 w-12" />
      </div>

      <h1 className="text-xl font-bold text-gray-800 sm:mb-4 sm:text-3xl">
        {title}
      </h1>
      <p className="text-base text-gray-600 sm:mb-4 sm:text-lg">{subTitle}</p>
    </div>
  );
}
